<template>
  <v-layout row wrap pt-2>
    <v-flex xs12 sm12 md4>
      <p class="mb-0 fs-14">チャットツール</p>
      <v-layout class="checkbox-group g1 mt--7">
        <v-checkbox
          @change="updateIncomeChannelOption" v-model="incomingSelected" value="TALK" label="チャット"
          class="ml-2"></v-checkbox>
        <v-checkbox
          @change="updateIncomeChannelOption" v-model="incomingSelected" value="CALL" label="電話"></v-checkbox>
        <v-checkbox
          @change="updateIncomeChannelOption" v-model="incomingSelected" value="CHAT_BOT" label="チャットボット"></v-checkbox>
        <v-checkbox
          @change="updateIncomeChannelOption" v-model="incomingSelected" value="MEMO" label="メモ"></v-checkbox>
        <v-checkbox
          @change="updateIncomeChannelOption" v-model="incomingSelected" value="MESSAGE" label="メッセージ"></v-checkbox>
        <v-checkbox
          @change="updateIncomeChannelOption" v-model="incomingSelected" value="MAIL" label="メール"></v-checkbox>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm12 md4>
      <p class="mb-0 fs-14">チケット状態の値</p>
      <v-layout class="checkbox-group g1 mt--7">
        <v-checkbox
          :disabled="statusDisabled"
          @change="updateStatusOption" v-model="statusSelected" value="ACTIVE" label="有効" class="ml-2"></v-checkbox>
        <v-checkbox
          :disabled="statusDisabled"
          @change="updateStatusOption" v-model="statusSelected" value="INACTIVE" label="無効"></v-checkbox>
        <v-checkbox
          :disabled="statusDisabled"
          @change="updateStatusOption" v-model="statusSelected" value="RESOLVED" label="解決"></v-checkbox>
        <v-checkbox
          :disabled="statusDisabled"
          @change="updateStatusOption" v-model="statusSelected" value="PENDING" label="保留"></v-checkbox>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm12 md4>
      <p class="mb-0 fs-14">優先順位</p>
      <v-layout class="checkbox-group g1 mt--7">
        <v-checkbox
          @change="updatePriorityOption" v-model="prioritySelected" value="EMERGENCY" label="緊急"
          class="ml-2"></v-checkbox>
        <v-checkbox
          @change="updatePriorityOption" v-model="prioritySelected" value="HIGH" label="高い"></v-checkbox>
        <v-checkbox
          @change="updatePriorityOption" v-model="prioritySelected" value="NORMAL" label="普通"></v-checkbox>
        <v-checkbox
          @change="updatePriorityOption" v-model="prioritySelected" value="LOW" label="低い"></v-checkbox>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import OptionType from '../../../enums/ticketListOptionType'

export default {
  props: {
    updateOption: Function,
    disableOption: {
      type: String,
      default: ''
    },
    pageType: String
  },
  data: () => ({
    tipDialog: false,
    selected: [],
    templates: [],
    pagination: {},
    incomingSelected: [],
    statusSelected: [],
    prioritySelected: [],
    statusDisabled: false
  }),
  components: {},
  methods: {
    excelDownload () {
      this.$emit('excel-download')
    },
    updateIncomeChannelOption () {
      this.updateOption('income', this.incomingSelected.length === 0 ? [] : this.incomingSelected)
    },
    updateStatusOption () {
      this.updateOption('status', this.statusSelected.length === 0 ? [] : this.statusSelected)
    },
    updatePriorityOption () {
      this.updateOption('priority', this.prioritySelected.length === 0 ? [] : this.prioritySelected)
    },
    resetAll () {
      this.incomingSelected = []
      this.statusSelected = this.disableOption === 'status' ? ['RESOLVED'] : []
      this.prioritySelected = []
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  created () {
    this.pagination.rowsPerPage = 12
  },
  mounted () {
    this.incomingSelected = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.INCOME, localStorage.getItem('TICKET_LIST_OPTION'))
    this.statusSelected = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.STATUS, localStorage.getItem('TICKET_LIST_OPTION'))
    this.prioritySelected = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.PRIORITY, localStorage.getItem('TICKET_LIST_OPTION'))

    if (this.disableOption === 'status') {
      this.statusDisabled = true
      this.statusSelected = ['RESOLVED']
      this.updateStatusOption()
    }
  }
}
</script>
<style>
  @import url("../../css/ticket_management.css");
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_select_option.vue